import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import dashboardPerformanceComparisonAxios from '../../axios/dashboardPerformanceComparison'
import { enqueueSnackbar } from './alert'

// dashboard_performance_comparison/chart_line

export const fetchDashboardPerformanceComparisonChartLine = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions
      // page: filterOptions ? filterOptions.page : 1,
      // perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchDashboardPerformanceComparisonChartLineStart())
    dashboardPerformanceComparisonAxios
      .get('/chart_line', { params })
      .then(response => {
        dispatch(fetchDashboardPerformanceComparisonChartLineSuccess(response.data.data))
      })
      .catch(error => {
        if (error?.response) {
          switch (error?.response?.status) {
            case 400:
              dispatch(
                enqueueSnackbar({
                  message: 'Fetch Dashboard Performance Comparison Failed',
                  options: {
                    variant: 'error',
                    data: error?.response?.data?.data ?? []
                  }
                })
              )
              break

            default:
              dispatch(
                enqueueSnackbar({
                  message: error?.response?.data?.message || '',
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
        }
        dispatch(fetchDashboardPerformanceComparisonChartLineFailed())
      })
  }
}

export const fetchDashboardPerformanceComparisonChartLineStart = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_START
  }
}

export const fetchDashboardPerformanceComparisonChartLineSuccess = records => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_SUCCESS,
    records
  }
}

export const fetchDashboardPerformanceComparisonChartLineFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_FAILED,
    errorMessage
  }
}

// dashboard_performance_comparison/chart_bar

export const fetchDashboardPerformanceComparisonChartBar = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions
      // page: filterOptions ? filterOptions.page : 1,
      // perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchDashboardPerformanceComparisonChartBarStart())
    dashboardPerformanceComparisonAxios
      .get('/chart_bar', { params })
      .then(response => {
        dispatch(fetchDashboardPerformanceComparisonChartBarSuccess(response.data.data))
      })
      .catch(error => {
        if (error?.response) {
          switch (error?.response?.status) {
            case 400:
              dispatch(
                enqueueSnackbar({
                  message: error?.response.data.message || '',
                  options: {
                    variant: 'error'
                  }
                })
              )
              break

            default:
              dispatch(
                enqueueSnackbar({
                  message: error?.response?.data?.message || '',
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
        }
        dispatch(fetchDashboardPerformanceComparisonChartBarFailed())
      })
  }
}

export const fetchDashboardPerformanceComparisonChartBarStart = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_START
  }
}

export const fetchDashboardPerformanceComparisonChartBarSuccess = records => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_SUCCESS,
    records
  }
}

export const fetchDashboardPerformanceComparisonChartBarFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_FAILED,
    errorMessage
  }
}

// dashboard_performance_comparison/data_kpi

export const fetchDashboardPerformanceComparisonDataKpi = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions
      // page: filterOptions ? filterOptions.page : 1,
      // perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchDashboardPerformanceComparisonDataKpiStart())
    dashboardPerformanceComparisonAxios
      .get('/data_kpi', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { data } = response.data.data

          const dataWithOption = data.map((item, index) => {
            return {
              ...item,
              index: getListingIndex(index)
            }
          })

          dispatch(fetchDashboardPerformanceComparisonDataKpiSuccess(dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchDashboardPerformanceComparisonDataKpiFailed(error))
      })
  }
}

export const fetchDashboardPerformanceComparisonDataKpiStart = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_START
  }
}

export const fetchDashboardPerformanceComparisonDataKpiSuccess = records => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_SUCCESS,
    records
  }
}

export const fetchDashboardPerformanceComparisonDataKpiFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_FAILED,
    errorMessage
  }
}
